import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { NgxSpinnerService } from "ngx-spinner";
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { take } from 'rxjs/operators';
import { AngularFireAuth } from "@angular/fire/auth";
import telefoneVerdadeiro from '../../funcoes/validar.telefone';

@Component({
  selector: 'app-consultar-funcionario',
  templateUrl: './consultar-funcionario.component.html',
  styleUrls: ['./consultar-funcionario.component.scss', '../../styles/estilo.padrao.scss']
})
export class ConsultarFuncionarioComponent implements OnInit {
  uid;
  bConsulta: boolean = false;
  consultaForm: FormGroup;
  funcionarioForm: FormGroup;

  displayedColumns: string[] = ['Nome', 'CPF', 'Email', 'Telefone', 'Gerente', 'StatusString', 'Consultar'];
  idFuncionarioCadastrado;
  funcionarioSource;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    private af: AngularFireAuth
  ) {
    this.uid = localStorage.getItem('uid');
    this.spinner.show('consultar-funcionario');

    //Pegar o funcionário recém cadastrado
    this.activatedRoute.queryParams.subscribe(value => {
      const dado = value;
      if (dado.IDFuncionario) {
        this.idFuncionarioCadastrado = dado.IDFuncionario;
      }
    });
  }

  //Máscaras
  maskTelefone = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  maskTelefone2 = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  ngOnInit(): void {
    this.usuarioService.getFuncionarios(this.uid).pipe(take(1)).subscribe(snap => {
      this.funcionarioSource = [];

      if (snap.length > 0) {
        let auxFornecedores: any[] = [];
        var dados;

        snap.forEach((item, index) => {
          dados = item.payload.val();

          if (item.key === this.idFuncionarioCadastrado) {
            this.consultarFuncionario({
              ID: item.key,
              Status: dados.Status,
              Nome: dados.Nome,
              CPF: dados.CPF,
              Telefone: dados.Telefone,
              TelefoneSecundario: dados.TelefoneSecundario,
              Email: dados.Email,
              IDMatriz: dados.IDMatriz,
              TimestampCadastro: dados.TimestampCadastro,
              DataHoraCadastro: this.usuarioService.tratarDataHora(dados.TimestampCadastro),
              Permissoes: dados.Permissoes,
              Gerente: dados.Permissoes.Gerente ? 'Sim' : '-',
              Comissao: 1
            });
          } else
            auxFornecedores.push({
              ID: item.key,
              Status: dados.Status,
              StatusString: dados.Status ? 'Ativo' : 'Desativado',
              Nome: dados.Nome,
              CPF: dados.CPF,
              Telefone: dados.Telefone,
              TelefoneSecundario: dados.TelefoneSecundario,
              Email: dados.Email,
              IDMatriz: dados.IDMatriz,
              TimestampCadastro: dados.TimestampCadastro,
              DataHoraCadastro: this.usuarioService.tratarDataHora(dados.TimestampCadastro),
              Permissoes: dados.Permissoes,
              Gerente: dados.Permissoes.Gerente ? 'Sim' : '-',
              Comissao: 1
            });
        });

        // this.usuarioService.setLog("Consulta geral de funcionários", null, this.uid);

        this.funcionarioSource = new MatTableDataSource(auxFornecedores);
        this.funcionarioSource.paginator = this.paginator;

        setTimeout(() => this.spinner.hide('consultar-funcionario'), 300);
      } else {
        this.toastr.error("Não foi possível localizar funcionários!", 'Erro');
        setTimeout(() => this.spinner.hide('consultar-funcionario'), 300);
      }
    });

    this.funcionarioForm = this.formBuilder.group({
      idFuncionario: ['', null],
      status: [false, null],
      email: ['', [Validators.email]],
      nome: ['', [Validators.required]],
      telefone: ['', [Validators.required, telefoneVerdadeiro]],
      telefoneSecundario: ['', null],
      cpf: ['', [Validators.required]],
      comissao: [1, Validators.required],
      dataCadastro: ['', null],
      bTodosCadastro: [false, null],
      bTodosConsulta: [false, null],
      bTodosAlterar: [false, null],
      bTodosExcluir: [false, null],
      bTodosDemaisFuncoes: [false, null],
      //Cadastrar
      bRealizarCadastroClientes: [false, null],
      bRealizarCadastroFornecedores: [false, null],
      bRealizarCadastroFuncionarios: [false, null],
      bRealizarCadastroGrupos: [false, null],
      bRealizarCadastroProdutos: [false, null],
      //Consultar
      bRealizarConsultaClientes: [false, null],
      bRealizarConsultaFornecedores: [false, null],
      bRealizarConsultaFuncionarios: [false, null],
      bRealizarConsultaGrupos: [false, null],
      bRealizarConsultaProdutos: [false, null],
      bRealizarConsultaLogs: [false, null],
      //Alterar
      bAlterarClientes: [false, null],
      bAlterarFornecedores: [false, null],
      bAlterarFuncionarios: [false, null],
      bAlterarGrupos: [false, null],
      bAlterarProdutos: [false, null],
      //Excluir
      bExcluirVendas: [false, null],
      bExcluirProdutos: [false, null],
      //Demais Funções
      bVender: [true, null],
      bGerente: [false, null],
    });
    this.funcionarioForm.get('cpf').disable();
    this.funcionarioForm.get('email').disable();
  }

  consultarFuncionario(dados) {

    this.usuarioService.setLog("Consulta detalhada de funcionário. ID " + dados.ID + ' Nome: ' + dados.Nome, null, this.uid);


    this.funcionarioForm.get('idFuncionario').patchValue(dados.ID);
    this.funcionarioForm.get('status').patchValue(dados.Status);
    this.funcionarioForm.get('nome').patchValue(dados.Nome);
    this.funcionarioForm.get('email').patchValue(dados.Email);
    this.funcionarioForm.get('telefone').patchValue(dados.Telefone);
    this.funcionarioForm.get('telefoneSecundario').patchValue(dados.TelefoneSecundario);
    this.funcionarioForm.get('cpf').patchValue(dados.CPF);
    this.funcionarioForm.get('comissao').patchValue(dados.Comissao);
    this.funcionarioForm.get('dataCadastro').patchValue(dados.DataHoraCadastro);
    this.funcionarioForm.get('comissao').disable()
    !dados.Permissoes.Gerente ? this.funcionarioForm.get('bGerente').disable() : this.funcionarioForm.get('bGerente').patchValue(true);

    //Permissoes
    //Cadastrar
    this.funcionarioForm.get('bRealizarCadastroClientes').patchValue(dados.Permissoes.Cadastrar.Clientes);
    this.funcionarioForm.get('bRealizarCadastroFornecedores').patchValue(dados.Permissoes.Cadastrar.Fornecedores);
    this.funcionarioForm.get('bRealizarCadastroFuncionarios').patchValue(dados.Permissoes.Cadastrar.Funcionarios);
    this.funcionarioForm.get('bRealizarCadastroGrupos').patchValue(dados.Permissoes.Cadastrar.Grupos);
    this.funcionarioForm.get('bRealizarCadastroProdutos').patchValue(dados.Permissoes.Cadastrar.Produtos);

    if (this.f.bRealizarCadastroClientes.value && this.f.bRealizarCadastroFornecedores.value && this.f.bRealizarCadastroFuncionarios.value && this.f.bRealizarCadastroGrupos.value && this.f.bRealizarCadastroProdutos.value) {
      this.funcionarioForm.get('bTodosCadastro').patchValue(true);
    }

    //Consultar
    this.funcionarioForm.get('bRealizarConsultaClientes').patchValue(dados.Permissoes.Consultar.Clientes);
    this.funcionarioForm.get('bRealizarConsultaFornecedores').patchValue(dados.Permissoes.Consultar.Fornecedores);
    this.funcionarioForm.get('bRealizarConsultaFuncionarios').patchValue(dados.Permissoes.Consultar.Funcionarios);
    this.funcionarioForm.get('bRealizarConsultaGrupos').patchValue(dados.Permissoes.Consultar.Grupos);
    this.funcionarioForm.get('bRealizarConsultaProdutos').patchValue(dados.Permissoes.Consultar.Produtos);
    this.funcionarioForm.get('bRealizarConsultaLogs').patchValue(dados.Permissoes.Consultar.Logs);

    if (this.f.bRealizarConsultaClientes.value && this.f.bRealizarConsultaFornecedores.value && this.f.bRealizarConsultaFuncionarios.value && this.f.bRealizarConsultaGrupos.value && this.f.bRealizarConsultaProdutos.value && this.f.bRealizarConsultaLogs.value) {
      this.funcionarioForm.get('bTodosConsulta').patchValue(true);
    }

    //Alterar
    this.funcionarioForm.get('bAlterarClientes').patchValue(dados.Permissoes.Alterar.Clientes);
    this.funcionarioForm.get('bAlterarFornecedores').patchValue(dados.Permissoes.Alterar.Fornecedores);
    this.funcionarioForm.get('bAlterarFuncionarios').patchValue(dados.Permissoes.Alterar.Funcionarios);
    this.funcionarioForm.get('bAlterarGrupos').patchValue(dados.Permissoes.Alterar.Grupos);
    this.funcionarioForm.get('bAlterarProdutos').patchValue(dados.Permissoes.Alterar.Produtos);

    if (this.f.bAlterarClientes.value && this.f.bAlterarFornecedores.value && this.f.bAlterarFuncionarios.value && this.f.bAlterarGrupos.value && this.f.bAlterarProdutos.value) {
      this.funcionarioForm.get('bTodosAlterar').patchValue(true);
    }

    //Excluir
    this.funcionarioForm.get('bExcluirProdutos').patchValue(dados.Permissoes.Excluir.Produtos);
    this.funcionarioForm.get('bExcluirVendas').patchValue(dados.Permissoes.Excluir.Vendas);

    if (this.f.bExcluirProdutos.value && this.f.bExcluirVendas.value) {
      this.funcionarioForm.get('bTodosExcluir').patchValue(true);
    }

    //Demais Funções
    if (this.f.bVender.value && this.f.bGerente.value) {
      this.funcionarioForm.get('bTodosDemaisFuncoes').patchValue(true);
    }

    this.bConsulta = true;
  }

  recuperarSenha() {
    this.af.sendPasswordResetEmail(this.f.email.value).then(resp => {
      this.toastr.success("Solicitação realizada com sucesso. Por favor verifique o e-mail cadastrado!", 'Status');

      this.usuarioService.setLog("Senha reenviada para o funcionário. ID: " + this.f.idFuncionario.value + ' Nome: ' + this.f.nome.value, null, this.uid);

    }).catch(err => {
      if (err.code === "auth/user-not-found") {
        this.toastr.error("Este e-mail não está cadastrado no sistema!", 'Erro');
      } else {
        this.toastr.error("Houve um erro na solicitação, por favor tente novamente mais tarde!", 'Erro');
      }

      this.usuarioService.setLog("Erro ao reenviar a senha para o funcionário. ID: " + this.f.idFuncionario.value + ' Nome: ' + this.f.nome.value + ' Erro: ' + err, null, this.uid);
    });
  }


  salvar() {
    this.spinner.show('default');

    if (this.funcionarioForm.valid) {
      const map: any = {
        Status: this.f.status.value,
        Nome: this.f.nome.value.trim(),
        CPF: this.f.cpf.value.trim(),
        Telefone: this.f.telefone.value.trim(),
        TelefoneSecundario: this.f.telefoneSecundario.value.trim(),
        Comissao: this.f.comissao.value,
        Permissoes: {
          Cadastrar: {
            Clientes: this.f.bRealizarCadastroClientes.value,
            Fornecedores: this.f.bRealizarCadastroFornecedores.value,
            Funcionarios: this.f.bRealizarCadastroFuncionarios.value,
            Grupos: this.f.bRealizarCadastroGrupos.value,
            Produtos: this.f.bRealizarCadastroProdutos.value,
          },
          Consultar: {
            Clientes: this.f.bRealizarConsultaClientes.value,
            Fornecedores: this.f.bRealizarConsultaFornecedores.value,
            Funcionarios: this.f.bRealizarConsultaFuncionarios.value,
            Grupos: this.f.bRealizarConsultaGrupos.value,
            Produtos: this.f.bRealizarConsultaProdutos.value,
            Logs: this.f.bRealizarConsultaLogs.value,
          },
          Alterar: {
            Clientes: this.f.bAlterarClientes.value,
            Fornecedores: this.f.bAlterarFornecedores.value,
            Funcionarios: this.f.bAlterarFuncionarios.value,
            Grupos: this.f.bAlterarGrupos.value,
            Produtos: this.f.bAlterarProdutos.value,
          },
          Excluir: {
            Vendas: this.f.bExcluirVendas.value,
            Produtos: this.f.bExcluirProdutos.value,
          },
          Vender: this.f.bVender.value,
          Gerente: this.f.bGerente.value,
        },
      }

      try {
        this.usuarioService.updateFuncionario(map, this.uid, this.f.idFuncionario.value, this.f.status.value).then(resp => {
          if (resp.Status) {
            this.toastr.success(resp.Mensagem, 'Status', { progressBar: true, positionClass: 'toast-top-center', });
            setTimeout(() => {
              this.spinner.hide('default');

              this.usuarioService.setLog("Alteração de funcionário. ID: " + this.f.idFuncionario.value + ' Nome: ' + this.f.nome.value, map, this.uid);

              this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                this.router.navigate(["/pages/consultar-funcionario"]));
            }, 1500);
          } else {
            this.toastr.error('Erro: ' + resp.Mensagem, 'Erro', { progressBar: true, positionClass: 'toast-top-center', });

            setTimeout(() => {
              this.spinner.hide('default');

              this.usuarioService.setLog("Erro na alteração de funcionário. ID: " + this.f.idFuncionario.value + ' Nome: ' + this.f.nome.value + ' Erro: ' + resp.Mensagem, null, this.uid);

              this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                this.router.navigate(["/pages/consultar-funcionario"]));
            }, 1500);
          }
        }).catch(err => {
          this.toastr.error('Erro: ' + err, 'Erro', { progressBar: true, positionClass: 'toast-top-center', });

          setTimeout(() => {
            this.spinner.hide('default');

            this.usuarioService.setLog("Erro CATCH na alteração de funcionário. ID: " + this.f.idFuncionario.value + ' Nome: ' + this.f.nome.value + ' Erro: ' + err, null, this.uid);

            this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
              this.router.navigate(["/pages/consultar-funcionario"]));
          }, 1500);
        });

      } catch (e) {
        console.log(e)
        this.spinner.hide('default');

        this.usuarioService.setLog("Erro CATCH2 na alteração de funcionário. ID: " + this.f.idFuncionario.value + ' Nome: ' + this.f.nome.value + ' Erro: ' + e, null, this.uid);

        this.toastr.error('Erro ao atualizar funcionário!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
        this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
          this.router.navigate(["/pages/consultar-funcionario"]));
      }

    } else {
      this.toastr.error('Preencha todos os campos corretamente!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
      this.funcionarioForm.markAllAsTouched();
      setTimeout(() => this.spinner.hide('default'), 500);
    }
  }

  aplicarFiltroTabela(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.funcionarioSource.filter = filterValue.trim().toLowerCase();

    if (this.funcionarioSource.paginator) {
      this.funcionarioSource.paginator.firstPage();
    }
  }

  allCheck(s) {
    switch (s) {
      case 'Cadastrar':
        if (this.f.bTodosCadastro.value) {
          this.funcionarioForm.get('bRealizarCadastroClientes').patchValue(false);
          this.funcionarioForm.get('bRealizarCadastroFornecedores').patchValue(false);
          this.funcionarioForm.get('bRealizarCadastroFuncionarios').patchValue(false);
          this.funcionarioForm.get('bRealizarCadastroGrupos').patchValue(false);
          this.funcionarioForm.get('bRealizarCadastroProdutos').patchValue(false);
        } else {
          this.funcionarioForm.get('bRealizarCadastroClientes').patchValue(true);
          this.funcionarioForm.get('bRealizarCadastroFornecedores').patchValue(true);
          this.funcionarioForm.get('bRealizarCadastroFuncionarios').patchValue(true);
          this.funcionarioForm.get('bRealizarCadastroGrupos').patchValue(true);
          this.funcionarioForm.get('bRealizarCadastroProdutos').patchValue(true);
        }
        break;

      case 'Consultar':
        if (this.f.bTodosConsulta.value) {
          this.funcionarioForm.get('bRealizarConsultaClientes').patchValue(false);
          this.funcionarioForm.get('bRealizarConsultaFornecedores').patchValue(false);
          this.funcionarioForm.get('bRealizarConsultaFuncionarios').patchValue(false);
          this.funcionarioForm.get('bRealizarConsultaGrupos').patchValue(false);
          this.funcionarioForm.get('bRealizarConsultaProdutos').patchValue(false);
          this.funcionarioForm.get('bRealizarConsultaLogs').patchValue(false);
        } else {
          this.funcionarioForm.get('bRealizarConsultaClientes').patchValue(true);
          this.funcionarioForm.get('bRealizarConsultaFornecedores').patchValue(true);
          this.funcionarioForm.get('bRealizarConsultaFuncionarios').patchValue(true);
          this.funcionarioForm.get('bRealizarConsultaGrupos').patchValue(true);
          this.funcionarioForm.get('bRealizarConsultaProdutos').patchValue(true);
          this.funcionarioForm.get('bRealizarConsultaLogs').patchValue(true);
        }
        break;

      case 'Alterar':
        if (!this.f.bTodosAlterar.value) {
          if (this.f.bRealizarConsultaClientes.value) {
            this.funcionarioForm.get('bAlterarClientes').enable();
            this.funcionarioForm.get('bAlterarClientes').patchValue(true);
          }

          if (this.f.bRealizarConsultaFornecedores.value) {
            this.funcionarioForm.get('bAlterarFornecedores').enable();
            this.funcionarioForm.get('bAlterarFornecedores').patchValue(true);
          }

          if (this.f.bRealizarConsultaFuncionarios.value) {
            this.funcionarioForm.get('bAlterarFuncionarios').enable();
            this.funcionarioForm.get('bAlterarFuncionarios').patchValue(true);
          }

          if (this.f.bRealizarConsultaGrupos.value) {
            this.funcionarioForm.get('bAlterarGrupos').enable();
            this.funcionarioForm.get('bAlterarGrupos').patchValue(true);
          }

          if (this.f.bRealizarConsultaProdutos.value) {
            this.funcionarioForm.get('bAlterarProdutos').enable();
            this.funcionarioForm.get('bAlterarProdutos').patchValue(true);

            this.funcionarioForm.get('bExcluirProdutos').enable();
          }
        } else {
          this.funcionarioForm.get('bAlterarClientes').patchValue(false);
          this.funcionarioForm.get('bAlterarFornecedores').patchValue(false);
          this.funcionarioForm.get('bAlterarFuncionarios').patchValue(false);
          this.funcionarioForm.get('bAlterarGrupos').patchValue(false);
          this.funcionarioForm.get('bAlterarProdutos').patchValue(false);
          this.funcionarioForm.get('bExcluirProdutos').disable();
          this.funcionarioForm.get('bExcluirProdutos').patchValue(false);
        }
        break;

      case 'Excluir':
        if (!this.f.bTodosExcluir.value) {
          this.funcionarioForm.get('bExcluirVendas').patchValue(true);
          if (this.f.bAlterarProdutos.value) {
            this.funcionarioForm.get('bExcluirProdutos').enable();
            this.funcionarioForm.get('bExcluirProdutos').patchValue(true);
          }
        } else {
          this.funcionarioForm.get('bExcluirVendas').patchValue(false);
          this.funcionarioForm.get('bExcluirProdutos').patchValue(false);
        }
        break;

      case 'DemaisFuncoes':
        if (!this.f.bTodosDemaisFuncoes.value) {
          this.funcionarioForm.get('bVender').patchValue(true);
          // this.funcionarioForm.get('bGerente').patchValue(true);
        } else {
          this.funcionarioForm.get('bVender').patchValue(false);
          this.funcionarioForm.get('bGerente').patchValue(false);
        }
        break;
    }
  }

  checkAlterado() {
    if (this.f.bRealizarConsultaClientes.value) {
      this.funcionarioForm.get('bAlterarClientes').enable();
    } else {
      this.funcionarioForm.get('bAlterarClientes').disable();
      this.funcionarioForm.get('bAlterarClientes').patchValue(false);
    }

    if (this.f.bRealizarConsultaFornecedores.value) {
      this.funcionarioForm.get('bAlterarFornecedores').enable();
    } else {
      this.funcionarioForm.get('bAlterarFornecedores').disable();
      this.funcionarioForm.get('bAlterarFornecedores').patchValue(false);
    }

    if (this.f.bRealizarConsultaFuncionarios.value) {
      this.funcionarioForm.get('bAlterarFuncionarios').enable();
    } else {
      this.funcionarioForm.get('bAlterarFuncionarios').disable();
      this.funcionarioForm.get('bAlterarFuncionarios').patchValue(false);
    }

    if (this.f.bRealizarConsultaGrupos.value) {
      this.funcionarioForm.get('bAlterarGrupos').enable();
    } else {
      this.funcionarioForm.get('bAlterarGrupos').disable();
      this.funcionarioForm.get('bAlterarGrupos').patchValue(false);
    }

    if (this.f.bRealizarConsultaProdutos.value) {
      this.funcionarioForm.get('bAlterarProdutos').enable();
    } else {
      this.funcionarioForm.get('bAlterarProdutos').disable();
      this.funcionarioForm.get('bAlterarProdutos').patchValue(false);
    }

    if (this.f.bAlterarProdutos.value) {
      this.funcionarioForm.get('bExcluirProdutos').enable();
    } else {
      this.funcionarioForm.get('bExcluirProdutos').disable();
      this.funcionarioForm.get('bExcluirProdutos').patchValue(false);
    }

  }

  voltar() {
    this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/pages/consultar-funcionario"]));
  }

  onChangeTel(e, b) {
    if (e.length >= 6) {
      if (e.substring(5, 6) === '9') {
        b ? this.maskTelefone = ['(', /\d/, /\d/, ')', ' ', '9', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] : this.maskTelefone2 = ['(', /\d/, /\d/, ')', ' ', '9', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      } else {
        b ? this.maskTelefone = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] : this.maskTelefone2 = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      }
    } else {
      b ? this.maskTelefone = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] : this.maskTelefone2 = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.funcionarioForm.controls; }

}
